import { ComponentPropsWithoutRef } from 'react';
import { Box } from '@givebutter/primitives/box';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import {
    CollapsibleContentProps,
    CollapsibleProps,
    CollapsibleTriggerProps,
} from '@radix-ui/react-collapsible';
import * as Collapsible from '@radix-ui/react-collapsible';
import { twMerge } from 'tailwind-merge';

interface AddMemberCollapsibleProps extends CollapsibleProps {}
const AddMemberCollapsible = (props: AddMemberCollapsibleProps) => {
    const { className, children, ...rest } = props;

    return (
        <Collapsible.Root asChild={true} {...rest}>
            <Box className={twMerge('group flex flex-col gap-4 bg-gray-100 p-4', className)}>
                {children}
            </Box>
        </Collapsible.Root>
    );
};

interface AddMemberCollapsibleTriggerProps extends CollapsibleTriggerProps {}
const AddMemberCollapsibleTrigger = (props: AddMemberCollapsibleTriggerProps) => {
    const { className, children, ...rest } = props;

    return (
        <Collapsible.Trigger className={'w-full'} {...rest}>
            <div className={twMerge('flex gap-6 sm:grid sm:grid-cols-12', className)}>
                {children}
            </div>
        </Collapsible.Trigger>
    );
};

interface AddMemberCollapsibleTriggerLeftProps extends ComponentPropsWithoutRef<'div'> {}
const AddMemberCollapsibleTriggerLeft = (props: AddMemberCollapsibleTriggerLeftProps) => {
    const { className, ...rest } = props;

    return <div className={twMerge('hidden sm:col-span-1 sm:block', className)} {...rest} />;
};

interface AddMemberCollapsibleTriggerRightProps extends ComponentPropsWithoutRef<'div'> {}
const AddMemberCollapsibleTriggerRight = (props: AddMemberCollapsibleTriggerRightProps) => {
    const { className, ...rest } = props;

    return (
        <div
            className={twMerge('flex w-full sm:col-span-11 sm:w-auto [&>*]:w-full', className)}
            {...rest}
        />
    );
};

interface AddMemberCollapsibleExpandIconProps extends Omit<FontAwesomeIconProps, 'icon'> {}
const AddMemberCollapsibleExpandIcon = (props: AddMemberCollapsibleExpandIconProps) => {
    const { className, ...rest } = props;

    return (
        <FontAwesomeIcon
            icon={faChevronLeft}
            className={twMerge('group-radix-state-open:-rotate-90', className)}
            {...rest}
        />
    );
};

interface AddMemberCollapsibleContentProps extends CollapsibleContentProps {
    innerClassName?: string;
}
const AddMemberCollapsibleContent = (props: AddMemberCollapsibleContentProps) => {
    const { innerClassName, children, ...rest } = props;

    return (
        <Collapsible.Content {...rest}>
            <div className={'flex gap-6 sm:grid sm:grid-cols-12'}>
                <div className={twMerge('flex sm:col-span-11 sm:col-start-2', innerClassName)}>
                    {children}
                </div>
            </div>
        </Collapsible.Content>
    );
};

const Root = AddMemberCollapsible;
const Content = AddMemberCollapsibleContent;
const ExpandIcon = AddMemberCollapsibleExpandIcon;
const Trigger = AddMemberCollapsibleTrigger;
const TriggerLeft = AddMemberCollapsibleTriggerLeft;
const TriggerRight = AddMemberCollapsibleTriggerRight;

export {
    AddMemberCollapsible,
    AddMemberCollapsibleContent,
    AddMemberCollapsibleExpandIcon,
    AddMemberCollapsibleTrigger,
    AddMemberCollapsibleTriggerLeft,
    AddMemberCollapsibleTriggerRight,
    //
    Root,
    Content,
    ExpandIcon,
    Trigger,
    TriggerLeft,
    TriggerRight,
};
